module.exports = __webpack_public_path__ + "static/media/radiator box 1.86a641cd.jpg";